import { useDispatch, useSelector } from 'react-redux';
import { useWidgetsQuery } from '../../api/useWidgetsQuery';
import { setGroupSelectionSelectedTabIndex } from '../../state/actions';
import { selectGroupSelectionData } from '../../state/selectors';
import { TabSlug } from '../../types';
import { WIDGETS_WITH_GROUP_SELECTION } from '../DesktopWidgets/DesktopWidgets.meta';

interface Params {
  id: string;
  tabSlug: TabSlug;
}

export const useGroupSelection = ({ id, tabSlug }: Params) => {
  const dispatch = useDispatch();

  const { data: widgetData = { included: [] } } = useWidgetsQuery({ tab: tabSlug });

  const { tabList, defaultTabIndex, selectedTabIndex, isLoading } = useSelector(
    selectGroupSelectionData(tabSlug),
  );

  const onTabChange = (index: number) => {
    dispatch(setGroupSelectionSelectedTabIndex(index, tabSlug));
  };

  const widgetsWithGroupSelection = WIDGETS_WITH_GROUP_SELECTION.filter(
    widgetId => widgetId !== id,
  );

  const currentWidgetIndex = widgetData.included.findIndex(widget => widget.id === id);

  // The `isHidden` flag hides the group selector if a widget above already includes one, avoiding duplication.
  const isHidden = widgetsWithGroupSelection.includes(
    widgetData.included[currentWidgetIndex - 1]?.id,
  );

  return {
    data: {
      isLoading,
      tabList,
      defaultTabIndex,
      selectedTabIndex,
      isHidden,
    },
    actions: {
      onTabChange,
    },
  };
};
